import { render, staticRenderFns } from "./PatientPrescriptionRequest.vue?vue&type=template&id=a455987a&scoped=true&lang=pug"
import script from "./PatientPrescriptionRequest.vue?vue&type=script&lang=js"
export * from "./PatientPrescriptionRequest.vue?vue&type=script&lang=js"
import style0 from "./PatientPrescriptionRequest.vue?vue&type=style&index=0&id=a455987a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a455987a",
  null
  
)

export default component.exports